import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {logout, selectUser} from './features/userSlice';
import {auth} from './firebase';
import './Header.css';
import { Link} from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search';
import HeaderOption from './HeaderOption';
import HomeIcon from '@material-ui/icons/Home';
import ChatIcon from '@material-ui/icons/Chat';
import AnnouncementIcon from '@material-ui/icons/Announcement';
//import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
//import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
//import NotificationsIcon from '@material-ui/icons/Notifications';


function Header() {
const user = useSelector(selectUser);
    const dispatch = useDispatch();
    const logoutOfApp = () => {
    dispatch(logout())
    auth.signOut();
    }
    return (
        <div className="header">
            <div className="header__left">
            
                <img src="CO+Laborar.png" alt="colaborar"/>
            
                {/*src="https://i.imgur.com/tIVv6CD.jpg"**/}
                <Link to="/" exact style={{textDecoration: 'none'}}>
                <p className="header__title" style={{color: '#69B2A1'}}>CO + LABORAR</p>
                </Link> 
                <div className="header__search">
                    <SearchIcon/>
                    <input placeholder="Search" type="text"/>
                </div>
            </div>
            
            <div className="header__right">
            <Link to="/" exact style={{textDecoration: 'none'}}>
                <HeaderOption Icon={HomeIcon} title='Home'/>
            </Link>  
            {/* <HeaderOption Icon={SupervisorAccountIcon} title='My Network'/> */}
            {/* <HeaderOption Icon={BusinessCenterIcon} title='Jobs'/> */}
            <Link to="/chat" exact style={{textDecoration: 'none'}}>
                <HeaderOption Icon={ChatIcon} title='#Channels'/>
            </Link>  
            <Link to="/news" exact style={{textDecoration: 'none'}}>
                <HeaderOption Icon={AnnouncementIcon} title='#News'/>
            </Link> 
             {/* <HeaderOption Icon={NotificationsIcon} title='Notifications'/>*/}
                <HeaderOption className="avatar" avatar={true} title="Log Out" src={user.photoUrl}  onClick={logoutOfApp}/>
            </div>
        </div>
    )
}

export default Header
